import { createFileRoute } from '@tanstack/react-router'

import { NnppReportDetailPage } from '@/src/pages/nnpp/reports/NnppReportDetailPage'

export const Route = createFileRoute('/nnpp/reports/$testId')({
  component: NnppReportDetailRoute,
  staticData: {
    layout: { enableScrolling: true },
  },
})

function NnppReportDetailRoute() {
  const { testId } = Route.useParams()
  return <NnppReportDetailPage testId={testId} />
}
